<div #htmlContent class="html-content" [innerHTML]="content"></div>
